export default {
  data() {
    return {
      unassigned_packages: [],
      agro_exporter_processes: [],
      packages: [],
      total_unassigned_packages: 0, // total de paquetes por asignar según el servidor, no referencia el total de la variable data en vue, sino en rails.
      weeks_unassigned_packages: [],
      unassigned_packages_by_weeks: {},
      comment: "",
      pg_code: "",
      grouped_at: null,
      agro_exporter_process_id: null,
    };
  },
  computed: {
    default_producer_id: function () {
      if (this.packages.length)
        return this.packages.slice(-1)[0]?.producer_id;
      return null;
    },
    default_organization_id: function () {
      if (this.packages.length)
        return this.packages.slice(-1)[0]?.organization_id;
      return null;
    },
    last_visible_from_stock_package: function () {
      let functional_packages = this.packages.filter(pkg => pkg.from_stock && !pkg._destroy && !pkg._remove);
      if (functional_packages.length > 0) return functional_packages[functional_packages.length - 1];
      return null;
    },
    new_assigned_packages: function () {
      return this.packages.filter(
        (package_item) => package_item.from_stock && package_item.id && !package_item._destroy
      );
    },
    new_assigned_package_ids: function () {
      return this.new_assigned_packages.map((package_item) => package_item.id);
    },
    package_default_week: function () {
      if (this.last_visible_from_stock_package) return this.last_visible_from_stock_package.week;
      // calculate based in grouped_at
      return null;
    },
    empty_to_assign_slots: function () {
      return this.packages.filter(
        (package_item) => package_item.from_stock && package_item.id == null
      ).length;
    },
    can_assign_other_package: function () {
      return this.total_unassigned_packages - this.new_assigned_package_ids.length - this.empty_to_assign_slots > 0;
    },
    total_packages: function () {
      const packages = this.packages.filter(p => !p._destroy && !p._remove && p.quantity);
      let quantity = packages.map(p => p.quantity).reduce((accumulator, currentValue) => {
        return accumulator + currentValue
      },0);
      return quantity;
    },
  },
  methods: {
    maxQuantityToAssign: function (package_item) {
      return this.unassigned_packages.find(option => option.id = package_item.id)?.quantity ?? 1;
    },
    addInitialPackage: function () {
      if (this.can_assign_other_package)
        this.addFromStockPackage();
    },
    emptyNewPackage: function () {
      return {
        quantity: null,
        from_stock: false,
        from_form: true, // quiere decir que ha sido creado en el formulario, pero todavia no se procesa en rails
      };
    },
    addPackage: function () {
      let new_package = this.emptyNewPackage();
      this.packages.push(new_package);
    },
    addFromStockPackage: function () {
      let new_package = { id: null, from_stock: true, from_form: true, week: this.package_default_week };
      this.packages.push(new_package);
    },
    // totdos los paquetes disponibles para asignar asignar.
    toAssignPackages: function (actual_package = null) {
      let isActualPackage = (package_item) =>
        actual_package ? package_item.id == actual_package?.id : false;
      return this.unassigned_packages.filter(
        (package_item) =>
          !this.new_assigned_package_ids.includes(package_item.id) ||
          isActualPackage(package_item)
      );
    },
    udpateUnassignedPackagesByWeek: function (week, packages) {
      if (this.unassigned_packages_by_weeks[week]) return;

      this.unassigned_packages_by_weeks[week] = packages;
    },
    validPackage: function (package_item) {
      if (package_item._remove) return false;
      if (package_item.from_stock) return Boolean(package_item.id);

      return (
        Boolean(package_item.exporter_process_crop_package_id) &&
        Boolean(package_item.exporter_process_crop_category_id) &&
        Boolean(package_item.exporter_process_crop_variety_id) &&
        Boolean(package_item.exporter_process_crop_size_id) &&
        Boolean(package_item.exporter_process_brand_id) &&
        Number(package_item.quantity) > 0 &&
        (Boolean(package_item.producer_id) ||
          Boolean(package_item.organization_id))
      );
    },
  }
}
